import React, { useState } from 'react'
import { Slideout, TextField, Typography, Button, Icon } from '@ann/web-components'
import {
	SlideoutContainer,
	SlideoutHeader,
	SlideoutSubHeader,
	SlideoutDrivesContainer,
	SlideoutActions
} from './SlideoutDriveDetail.styled';
import { useStore } from '../../../../../../../hooks';
import { observer } from "mobx-react";
import ListDocumentView from './pages/ListDocumentView/ListDocumentView';

const SlideoutDriveDetail = observer(({open, onClose}) => {
	const [selectedDocuments, setSelectedDocuments] = useState([]);
	const [searchTerm, setSearchTerm] = useState('');

	const handleGoToDrive = () => {
		console.log('handle go to drive');
	}

	const handleDocumentSelection = (documentTitle, isChecked) => {
		if (isChecked) {
			setSelectedDocuments(prev => [...prev, documentTitle]);
		} else {
			setSelectedDocuments(prev => prev.filter(title => title !== documentTitle));
		}
	}

	const handleSearchChange = (value) => {
		setSearchTerm(value);
	}

    return (
        <>
            <Slideout onClose={onClose} size="medium" open={open}>
			        <Slideout.HeaderActions>
				        <Icon name="arrowLeft" size="large" onClick={onClose}/>
			        </Slideout.HeaderActions>
	            
              <SlideoutContainer>
                  <SlideoutHeader>
                      <SlideoutSubHeader>
                          <Typography category="title" size="large" weight="bold">
                            Drive-01
                          </Typography>
                      </SlideoutSubHeader>
                      <TextField
                          size="medium"
                          iconLeft="search"
                          placeholder="Browse folders and files"
                          value={searchTerm}
                          onChange={handleSearchChange}
                      />
                  </SlideoutHeader>
	                <>{/* todo: add description*/ }</>
                  <SlideoutDrivesContainer>
                      <ListDocumentView 
                        selectedDocuments={selectedDocuments}
                        onDocumentSelection={handleDocumentSelection}
                        searchTerm={searchTerm}
                      />
                  </SlideoutDrivesContainer>
	            {/* <SlideoutActions>
		            <Button label="Go to drive" size="medium" type="primary" onClick={handleGoToDrive}/>
	            </SlideoutActions> */}
              </SlideoutContainer>
            </Slideout>
        </>
    )
})

export default SlideoutDriveDetail
